import webClient from "../config/api.config";
import { UpdateUserSettingsPayload } from "../types/userSettings.definition";

export function getDisabledUsers() {
  return webClient.request({
    method: "get",
    url: "users/disabled",
  });
}

export function reactivateUser(id: number) {
  return webClient.request({
    method: "put",
    url: `users/${id}/reactivate`,
  });
}

export function getUnverifiedUsers() {
  return webClient.request({
    method: "get",
    url: "users/unverified",
  });
}

export function verifyUser(id: number) {
  return webClient.request({
    method: "put",
    url: `users/${id}/verify`,
  });
}

export function updateAppLanguage(userId: string, lang: string) {
  return webClient.request({
    method: "put",
    url: `users/${userId}/settings/language`,
    params: { lang },
  });
}

/**
 * MED-1448: the logged-in administrator's own account.
 */
export function getUserById(userId: string) {
  return webClient.request({
    method: "get",
    url: `users/${userId}`,
  });
}

/**
 * MED-1448: the only field of a user account the BFF lets its owner change on
 * its own. `PUT /users/{id}` reuses the create-shaped `UserRequest`, whose
 * `password` is a mandatory non-null field that the API then discards — so it
 * cannot be used for a self-service profile edit.
 */
export function updateUserProfileImage(userId: string, photoUrl: string) {
  return webClient.request({
    method: "put",
    url: `users/${userId}/profile-image`,
    data: { photoUrl },
  });
}

/** MED-1449: the administrator's own settings. */
export function getUserSettings(userId: string) {
  return webClient.request({
    method: "get",
    url: `users/${userId}/settings`,
  });
}

/**
 * MED-1449: replaces every settings field — theme, timezone and visibility
 * are NOT NULL on both backends, so the caller must send back what it read.
 */
export function updateUserSettings(
  userId: string,
  data: UpdateUserSettingsPayload
) {
  return webClient.request({
    method: "put",
    url: `users/${userId}/settings`,
    data,
  });
}
